import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import moment from 'moment';
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {QuestionnaireService} from "../../../../services/questionnaire/questionnaire.service";

@Component({
  selector: 'app-selected-questionnaire',
  templateUrl: './selected-questionnaire.component.pug',
  styleUrls: ['./selected-questionnaire.component.scss'],
  standalone: false
})
export class SelectedQuestionnaireComponent implements OnInit, OnChanges {
  @Input() selectedQuestionnaire: any;
  @Input() showDeleteButton?: boolean; // Allow parent to control delete button visibility (undefined = use default logic)
  @Output() deleted = new EventEmitter();
  @Output() questionnaire = new EventEmitter();

  isReferenceSurvey = false;

  constructor(private permissions: PermissionsService) {
  }
  readonly surveyIcons = {
  exit: 'https://assets.xref.com/omni/shared/exits_icon.svg',
  reference: 'https://assets.xref.com/omni/shared/new_reference_icon.svg',
  pulse: 'https://assets.xref.com/omni/shared/pulse_icon.svg',
  background: 'https://assets.xref.com/omni/shared/background_check.svg'
};

  ngOnInit(): void {
    this.isReferenceSurvey = this.selectedQuestionnaire?.survey_type === QuestionnaireService.survey_type_mapping.reference.toString();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setFormattedDate(this.selectedQuestionnaire);
    this.questionnaire.emit(this.selectedQuestionnaire);
  }
  getIcon(q: any) {
  if (!q) return this.surveyIcons.reference;

  let typeKey = '';
  switch (q.survey_type) {
    case '1': // Exit
      typeKey = 'exit';
      break;
    case '2': // Pulse
      typeKey = 'pulse';
      break;
    case '3': // Reference
      typeKey = 'reference';
      break;
    case '4': // Background
      typeKey = 'background';
      break;
    default:
      typeKey = 'reference';
  }

  return this.surveyIcons[typeKey];
}

  deleteQuestionnaireSelection() {
    this.deleted.emit('true')
  }

  setFormattedDate(selectedQuestionnaire){
    if(selectedQuestionnaire['last_used']){
      selectedQuestionnaire['last_used_formatted'] = moment(selectedQuestionnaire['last_used']).format('ll');
    }
    if(selectedQuestionnaire['modified']){
      selectedQuestionnaire['modified_formatted'] = moment(selectedQuestionnaire['modified']).format('ll');
    }
  }

}
